import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const formatPrice = (n, cur = "RON") =>
  new Intl.NumberFormat("ro-RO", { style: "currency", currency: cur, maximumFractionDigits: 0 }).format(n);

export const imgUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);
